var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.465,
    height: 101.097,
    viewBox: "0 0 283.465 101.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37849",
    "data-name": "Path 37849",
    d: "M154.587,35.209c0,9.742-14.768,9.742-14.768,0s14.768-9.734,14.768,0m-13.641,64.8H153.46V49.259H140.946Z",
    transform: "translate(0 0.001)",
    fill: "#1c1c1c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37850",
    "data-name": "Path 37850",
    d: "M137.487,49.22l-21.515,50.821H102.45L80.827,49.22H94.458l6.966,16.7,7.783,21.306,7.683-21.106,6.974-16.9Z",
    transform: "translate(0 0.001)",
    fill: "#1c1c1c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37851",
    "data-name": "Path 37851",
    d: "M54.847,28.3V99.969H43.16L42.341,93c-3.9,6.044-10.151,8.1-16.3,8.1C11.17,101.1,0,91.253,0,74.649,0,57.218,10.969,48.194,25.729,48.194c5.334,0,13.64,2.872,16.612,8.1V28.3ZM12.505,74.649c0,8.816,6.362,14.86,14.35,14.86,7.9,0,14.668-5.736,14.668-14.86A14.427,14.427,0,0,0,26.855,59.881c-7.988,0-14.35,5.635-14.35,14.768",
    transform: "translate(0 0.001)",
    fill: "#1c1c1c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37852",
    "data-name": "Path 37852",
    d: "M182.378,35.209v14.03h13.941V60h-14.05V82.167c0,4.817,2.672,7.18,6.562,7.18a14.33,14.33,0,0,0,6.052-1.537l3.49,10.661a28.072,28.072,0,0,1-10.36,2.154c-10.969.409-18.149-5.844-18.149-18.458V60h-9.433V49.239h9.433V36.545Z",
    transform: "translate(0 0.001)",
    fill: "#1c1c1c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37853",
    "data-name": "Path 37853",
    d: "M78.453,35.171c0,9.742-14.767,9.742-14.767,0s14.767-9.734,14.767,0m-13.64,64.8H77.327V49.221H64.813Z",
    transform: "translate(0 0.001)",
    fill: "#1c1c1c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37854",
    "data-name": "Path 37854",
    d: "M234.722,56.283l-1.25,14.071,1.25,14.071,12.186-7.036,12.185-7.035-10.936-8.285Z",
    transform: "translate(0 0.001)",
    fill: "#f93",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37855",
    "data-name": "Path 37855",
    d: "M259.094,42.212l-1.25,14.071,1.25,14.071,12.186-7.036,12.185-7.035L272.529,48Z",
    transform: "translate(0 0.001)",
    fill: "#c00",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37856",
    "data-name": "Path 37856",
    d: "M259.094,42.212l-1.25-14.071,1.25-14.071,12.186,7.036,12.185,7.035-10.936,8.285Z",
    transform: "translate(0 0.001)",
    fill: "#609",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37857",
    "data-name": "Path 37857",
    d: "M259.094,42.212l12.186-7.035,12.185-7.036V56.283L271.28,49.247Z",
    transform: "translate(0 0.001)",
    fill: "#909",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37858",
    "data-name": "Path 37858",
    d: "M234.722,28.141l-1.25-14.071L234.722,0l12.186,7.036,12.185,7.035-10.936,8.285Z",
    transform: "translate(0 0.001)",
    fill: "#03c",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37859",
    "data-name": "Path 37859",
    d: "M234.722,28.141l12.186-7.035,12.185-7.036V42.212l-12.185-7.036Z",
    transform: "translate(0 0.001)",
    fill: "#009",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37860",
    "data-name": "Path 37860",
    d: "M210.351,35.192h24.372V0L222.537,7.036l-12.186,7.035",
    transform: "translate(0 0.001)",
    fill: "#09f",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37861",
    "data-name": "Path 37861",
    d: "M210.351,49.233h24.372V84.425l-12.186-7.036-12.186-7.035",
    transform: "translate(0 0.001)",
    fill: "#fc3",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37862",
    "data-name": "Path 37862",
    d: "M234.722,56.283l12.186,7.035,12.185,7.036V42.212l-12.185,7.036Z",
    transform: "translate(0 0.001)",
    fill: "#f63",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivit);
export default __webpack_public_path__ + "static/media/divit.ca4253f62fb2f0dad2b394a062af4f25.svg";
export { ForwardRef as ReactComponent };